import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'dashboard_auto.mes_contracts.title',
  },
  dateEcheance: {
    id: 'dashboard_auto.mes_contracts.date_echeance',
  },
  numPolice: {
    id: 'dashboard_auto.mes_contracts.num_police',
  },
  voirTous: {
    id: 'dashboard_auto.mes_contracts.voir_tous',
  },
  Actif: {
    id: 'dashboard_auto.mes_contracts.actif',
  },
  Encours: {
    id: 'dashboard_auto.mes_contracts.encours',
  },
});
